import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Mayotte: Country = {
    identifier: "Mayotte",
    name: "Mayotte",
    countryCode: "YT",
    group: CountryGroup.AFRICA,
    isUNMember: false,
    flag: "🇾🇹",
    svgPath: "m 601.69375,499.4144 -0.177,0.024 -0.083,-0.076 -0.051,-0.18 0.052,-0.173 0.015,-0.14 -0.143,-0.243 0.14,-0.138 0.119,0.161 0.068,0.011 0.18,0.112 -0.053,0.206 0.012,0.068 -0.082,0.206 z",
}
